import protoRoot from "./proto-root";
import debug from "src/modules/debug-logger";

// const protobuf = window.require("protobufjs");
import protobuf from "protobufjs";

export function createEnvelopeBuffer(payload) {
  const Envelope = protoRoot.lookupType("comm.Envelope");
  debug.protoBuffers("About to create EnvelopeBuffer, payload", payload);

  const err = Envelope.verify(payload);
  if (err) {
    debug.messenger(err);
  }
  const envelope = Envelope.create(payload);
  debug.protoBuffers("Created Envelope", envelope);

  const buffer = Envelope.encode(envelope).finish();
  debug.protoBuffers("EnvelopeBuffer created", buffer);
  return buffer;
}

function encodeEnvelopeToBase64(envelopeBuffer) {
  return protobuf.util.base64.encode(envelopeBuffer, 0, envelopeBuffer.length);
}

export function prepareEnvelope({ payload, sendBy }) {
  if (payload.message && payload.message.audioPacket) {
    debug.audioProcessing("Preparing audioPacket", payload);
  } else if (payload.rpcRequest && payload.rpcRequest.pingRequest) {
    debug.pingPong(`Preparing pingRequest`, payload);
  } else if (payload.rpcResponse && payload.rpcResponse.pingResponse) {
    debug.pingPong(`Preparing pingResponse`, payload);
  } else {
    debug.messenger(`Preparing envelope for ${sendBy}, payload:`, payload);
  }

  const envelopeBuffer = createEnvelopeBuffer(payload);
  if (sendBy === "dataChannel") {
    return envelopeBuffer;
  }

  return encodeEnvelopeToBase64(envelopeBuffer);
}
